import { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import { Tab } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import Modal from '../../components/Modal/Modal';
import FormTextInput from '../../components/Form/FormTextInput';
import { REPORT_PATH } from '../../routes';

const ReportModal = ({
                                 open, onClose, requestObject
                             }) => {
    const onCloseButtonClickHandler = () => {
        onClose();
    };

    const navigate = useNavigate();
    const [formikInitialValues, setFormikInitialValues] = useState({
        customer: '',
        project: '',
    });

    const validationSchema = Yup.object().shape({
        customer: Yup.string(),
        project: Yup.string(),
    });

    const onSubmitHandler = async (formData) => {
        // console.log(formData);
        navigate(
            `${REPORT_PATH}`,
            {
                state:
                    {
                        data: JSON.stringify({
                            requestObject,
                            customerName: formData.customer,
                            projectName: formData.project
                        })
                    }
            }
        );
        onCloseButtonClickHandler();
        try {
            toast.success('Success');
        } catch {
            toast.error('Something went wrong. Please try again');
        }
    };

    return (
        <Modal open={open} setOpen={onCloseButtonClickHandler}>
            <div className="px-2">
                <Tab.Group>
                    <Tab.Panels>
                        <Formik
                            enableReinitialize
                            initialValues={formikInitialValues}
                            validationSchema={validationSchema}
                            onSubmit={onSubmitHandler}
                        >
                            {({ errors }) => (
                                <Form className="flex flex-col gap-2 py-4">
                                    <FormTextInput name="customer" label='Customer Name' />
                                    <FormTextInput name="project" label='Project Name' />
                                    <button
                                        // isBlock
                                        // disabled={Object.keys(errors).length > 0 || isLoading}
                                        type="submit"
                                        // isLoading={isLoading}
                                    >
                                        Continue
                                    </button>
                                </Form>
                            )}
                        </Formik>
                    </Tab.Panels>
                </Tab.Group>
            </div>
        </Modal>
    );
};

ReportModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    requestObject: PropTypes.array.isRequired,
};

export default ReportModal;
